import React from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import type { Theme } from '@mui/material';

export default {
	styleOverrides: {
		inputRoot: {
			paddingRight: '47px',
		},
		input: {
			boxShadow: 'none',
		},
		popupIndicator: {
			margin: 0,
			width: '26px',
			height: '26px',
			transition: 'all .3s',
		},
		clearIndicator: {
			width: '32px',
			height: '32px',
			transition: 'all .3s',
		},
		buttonBase: {
			width: '40px',
			height: '40px',
		},
		paper: {
			background: 'rgba(255,255,255,0.7)',
			marginTop: '10px',
			backdropFilter: 'blur(5px)',
		},
		listbox: {
			paddingBlock: 0,
		},
		tag: ({ theme }: { theme: Theme }) => ({
			padding: '2px',
			height: 'auto',
			borderRadius: '8px',
			background: theme.palette.primary.contrastText,
			color: theme.palette.primary.main,
			border: `1px solid ${theme.palette.primary.main}`,

			'& .MuiSvgIcon-root': {
				width: '18px',
				height: '18px',
				color: theme.palette.primary.main,
				margin: '0px 5px 2px -6px',

				'&:hover': {
					color: theme.palette.primary.light,
				},
			},
		}),
	},
	defaultProps: {
		popupIcon: <KeyboardArrowDownIcon />,
	},
};
